const fallbackLng = 'en';

export const languages = {
  en: 'English',
  // es: 'Español',
  // pt: 'Português',
};

type Languages = typeof languages;

export type Locales = keyof Languages;

export function getLocale(locale: string): Locales {
  const loc = locale as Locales;
  return languages[loc] ? loc : fallbackLng;
}

export function getLanguage(locale: string) {
  return languages[getLocale(locale)];
}

export const commonInitValues = {
  supportedLngs: Object.keys(languages),
  defaultNS: 'root',
  fallbackLng,
  // disabling suspense is recommended
  react: { useSuspense: false },
  // debug: process.env.NODE_ENV !== 'production',
  interpolation: {
    escapeValue: false, // react already safe from xss
  },
};
